import React, { useState } from "react";
import PreConferenceHeader from "./PreConferenceHeader";
import PreconferenceSpeaker from "./PreconferenceSpeaker";
import WSRandGuidelines from "./WSRandGuidelines";
import PCScientificCommittee from "./PCScientificCommittee";

const PreConferenceWorkshop = () => {
  return (
    <div style={{ background: "#fff3fa" }}>
      <PreConferenceHeader />
      <PreconferenceSpeaker />
      <WSRandGuidelines />
      <PCScientificCommittee />
    </div>
  );
};
export default PreConferenceWorkshop;
